// extracted by mini-css-extract-plugin
export default {"toast":"globaltoast_toast__EMcTC","warning":"globaltoast_warning__Y9Dcr","error":"globaltoast_error__P2C65","success":"globaltoast_success__AbxOC"};